import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "change-subscription__container" }
const _hoisted_2 = { class: "change-subscription__header m-bottom-36" }
const _hoisted_3 = { class: "change-subscription__header--title m-right-15" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Below are the monthly subscription options. The batch job pricing is the same across all of our plans, but the standard and premium plans waive the minimum job costs provide access to our FTP service. The premium plan also provides access to our API. ", -1)
const _hoisted_5 = { class: "change-subscription__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubscriptionCard = _resolveComponent("SubscriptionCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    class: "modal-change-subscription",
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
            _hoisted_4
          ]),
          (_ctx.showRates)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn fill mini medium",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDetailsRates && _ctx.showDetailsRates(...args)))
              }, "Show Details Rates"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$props.plans, (plan, id) => {
            return (_openBlock(), _createBlock(_component_SubscriptionCard, {
              key: id,
              plan: plan,
              onClose: _ctx.closeModal
            }, null, 8, ["plan", "onClose"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}